import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

export default function ArticleList() {
  return (
    <section className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-10">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-3">
              最新资讯
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              韩漫资讯与推荐
            </h2>
          </div>
          <Link
            to="/article/1"
            className="flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            更多文章
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:bg-background-200 transition-colors"
            >
              {/* Thumbnail */}
              <div className="aspect-video overflow-hidden bg-background-200">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2.5">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <span className="text-foreground-400 text-xs">· {article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}